






















































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Dictionary } from "vuex";
import ApiFactory from "@/api/ApiFactory";
import {
  KeyValuePairOfDateTimeAndDecimal,
  PerformanceChartDataDto
} from "@/api/ClientPortalApiClient";
import { UserStore, LoadingSpinnerService } from "@/store";

@Component
export default class PortfolioPerformanceColumnChart extends Vue {
  @Prop() policyId: number | undefined;
  @Prop() contactId: number | undefined;
  @Prop() id: number | undefined;
  @Prop() perform: number | undefined;

  private noData: boolean = false;

  private altdata: Dictionary<number> | null = null;

  private chartOptions = {
    tooltip: {
      trigger: "none"
    },
    chartArea: {
      right: 10,
      left: 40,
      top: 10,
      bottom: 30
    },
    vAxis: {
      format: "short"
    },
    hAxis: {
      textStyle: { color: "white" }
    },
    legend: {
      position: "bottom"
    }
  };

  async mounted() {
    await this.getaltdata();
  }

  private async getaltdata() {
    if (!this.contactId || !this.id) throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    this.altdata = await api.funds_GetPortfolioPerformance(
      UserStore.profileId,
      3,
      this.id
    );
  }
}
